import { Button, Confirm, Dropdown, Form, Header, Icon, Tab } from 'semantic-ui-react'

import Details from './guide/details'
import Images from './guide/images'
import Messages from '../Messages.js'
import PermissionsManager from '../PermissionsManager'
import React from 'react'
import { convertGraphQlToObject } from '../../helpers/contentWithI18n'
import { inlineStyle } from '../../styles/custom'
import { languages } from '../../constants'

const renderPanes = (obj, onChange) => {
  let panes = languages.map((language) => {
    const attrs = {obj: obj, language: language, onChange: onChange}
    return {menuItem: language.label, render: () => <Tab.Pane key={language.code} attached={false}><Details {...attrs} /></Tab.Pane>}
  })

  panes.push({menuItem: 'Gestion des médias', render: () => <Tab.Pane attached={false}><Images obj={obj} onChange={onChange} /></Tab.Pane>})

  return panes
}

const renderPlaces = (places) => {
  let _places = [{ value: null, text: '--' }]
  places.forEach(place => {
    _places.push({value: String(place.id), text: place.name})
  })
  return _places
}

const renderGuides = (guides) => {
  let _guides = [{ value: null, text: '--' }]
  guides.forEach(guide => {
    const guideWithTranslations = convertGraphQlToObject(guide)
    _guides.push({value: guide.id, text: guideWithTranslations.translations['fr'].title})
  })
  return _guides
}

const renderCourses = (courses) => {
  let _courses = [{ value: null, text: '--' }]
  courses.forEach(course => {
    _courses.push({value: course.id, text: course.detail.title})
  })
  return _courses
}

// const renderCenturies = () => {
//   return [
//     {value: 'I', text: '1er siècle'},
//     {value: 'II', text: '2ème siècle'},
//     {value: 'III', text: '3ème siècle'},
//     {value: 'IV', text: '4ème siècle'},
//     {value: 'V', text: '5ème siècle'},
//     {value: 'VI', text: '6ème siècle'},
//     {value: 'VII', text: '7ème siècle'},
//     {value: 'VIII', text: '8ème siècle'},
//     {value: 'IX', text: '9ème siècle'},
//     {value: 'X', text: '10ème siècle'},
//     {value: 'XI', text: '11ème siècle'},
//     {value: 'XII', text: '12ème siècle'},
//     {value: 'XIII', text: '13ème siècle'},
//     {value: 'XIV', text: '14ème siècle'},
//     {value: 'XV', text: '15ème siècle'},
//     {value: 'XVI', text: '16ème siècle'},
//     {value: 'XVII', text: '17ème siècle'},
//     {value: 'XVIII', text: '18ème siècle'},
//     {value: 'XIX', text: '19ème siècle'},
//     {value: 'XX', text: '20ème siècle'},
//     {value: 'XXI', text: '21ème siècle'}
//   ]
// }

const GuideForm = ({ obj, status, places, guides, courses, onChange, onSubmit, onDelete }) => {
  let place = null
  let placeId = null
  if (obj.place_id && places) {
    const objPlaceId = parseInt(obj.place_id, 10)
    place = places.getPlaces.find(item => item.id === objPlaceId)
    if (place) {
      placeId = String(place.id)
    }
  }

  return (
    <Form>
      <Header>Fiche audio-guide{status.isNew ? ' : Création' : ' : Édition'}</Header>
      <Messages errors={status.errors} />
      <Form.Field>
        <Button.Group size='large'>
          {obj.type === 'court' ? <Button active>Cours</Button> : <Button id="court" onClick={onChange}>Cours</Button>}
          {obj.type === 'medallion' ? <Button active>Médaillon</Button> : <Button id="medallion" onClick={onChange}>Médaillon</Button>}
        </Button.Group>
      </Form.Field>
      <Form.Field>
        <Button.Group size='large'>
          {obj.status === 'advised' ? <Button active>Conseillé</Button> : <Button id="advised" onClick={onChange}>Conseillé</Button>}
          {obj.status === 'available_soon' ? <Button active>Bientôt disponible</Button> : <Button id="available_soon" onClick={onChange}>Bientôt disponible</Button>}
          {obj.status === 'available' ? <Button active>Disponible</Button> : <Button id="available" onClick={onChange}>Disponible</Button>}
        </Button.Group>
      </Form.Field>
      {/* <Form.Group widths='equal'>
        <Form.Dropdown placeholder='Siècle' fluid selection closeOnChange id='century_1' value={obj.century_1} options={renderCenturies()} onChange={(e, data) => onChange(e, data, 'dropdown')} />
        <Form.Dropdown placeholder='Autre siècle (optionnel)' fluid selection closeOnChange id='century_2' value={obj.century_2} options={renderCenturies()} onChange={(e, data) => onChange(e, data, 'dropdown')} />
      </Form.Group> */}
      <Form.Group widths='equal'>
        <Form.Input label='Ordre' placeholder="Ordre" id="order" type="number" value={obj.order} onChange={onChange} />
        <Form.Input label='Durée' placeholder="Durée en seconde" id="duration" value={obj.duration} onChange={onChange} />
      </Form.Group>
      <Form.Field>
        <label>Emplacement</label>
        {
          places.loading ? <div>Chargement des emplacements</div> :
            <Dropdown placeholder='Sélectionnez un emplacement' fluid selection closeOnChange id='place_id' value={placeId} options={renderPlaces(places.getPlaces)} onChange={(e, data) => onChange(e, data, 'dropdown')} />
        }
      </Form.Field>
      <Form.Field>
        <label>Cible du push Vous pouvez aussi</label>
        {
          guides.loading ? <div>Chargement des audio-guides</div> :
            <Dropdown placeholder='Sélectionnez un audio-guide' fluid selection closeOnChange id='guide_id' value={obj.guide_id} options={renderGuides(guides.getGuides)} onChange={(e, data) => onChange(e, data, 'dropdown')} />
        }
      </Form.Field>
      <Form.Field>
        <label>Parcours</label>
        {
          courses.loading ? <div>Chargement des parcours</div> :
            <Dropdown placeholder='Sélectionnez un parcours' fluid selection closeOnChange id='course_id' value={obj.course_id} options={renderCourses(courses.getCourses)} onChange={(e, data) => onChange(e, data, 'dropdown')} />
        }
      </Form.Field>
      <Tab menu={{ pointing: true }} panes={renderPanes(obj, onChange)} />
      <br /><br />
      <Form.Field>
        <PermissionsManager hasPermissions={['create_guide', 'update_guide']}>
          {status.loading ? <Button type='submit' floated='left' color='red' loading> Chargement...</Button> :
            <Button type='submit' floated='left' color='olive' onClick={onSubmit}><Icon name="save" /> Sauvegarder</Button>
          }
        </PermissionsManager>
        {!status.isNew ? (
          <div>
            <PermissionsManager hasPermissions={['delete_guide']}>
              <Button type='submit' color='red' floated='right' onClick={(guide, data) => { onDelete(guide, { confirm: true }) }}><Icon name="delete" /> Suppression</Button>
            </PermissionsManager>
          </div>
        ) : null}
      </Form.Field>
      <Confirm
        content='Êtes-vous sûr(e) de vouloir supprimer cet audio-guide ? Cette action est définitive.'
        open={status.deletion.confirm} onCancel={(guide, data) => { onDelete(guide, { confirm: null }) }}
        onConfirm={(guide, data) => { onDelete(guide, { confirm: false }) }} style={inlineStyle.modal}
        cancelButton='Annuler'
        confirmButton='Ok'
      />
    </Form>
  )
}

export default GuideForm



// WEBPACK FOOTER //
// ./src/components/form/Guide.js